import React, { Component } from 'react';
import {
  Badge,
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  CustomInput,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Form,
  FormGroup,
  Input,
  Row,
  Table } from 'reactstrap';
import { DateRangePicker } from 'react-date-range';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

class CorpMerchants extends Component {
  state = {
    datesModalOpen: false,
    dropdownOpen: false,
    filterActive: false
  }

  handleSelect(ranges){
		console.log(ranges);
	}

  handleOpenDates = () => {
    this.setState({
      datesModalOpen: true
    });
  }

  handleCloseDates = () => {
    this.setState({
      datesModalOpen: false
    });
  }

  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  handleFilterApply = () => {
    this.setState({
      dropdownOpen: false,
      filterActive: true
    });
  }

  handleFilterCancel = () => {
    this.setState({
      dropdownOpen: false,
      filterActive: false
    });
  }

  render() {
    const { datesModalOpen, filterActive } = this.state;
    const selectionRange = {
			startDate: new Date(),
			endDate: new Date(),
			key: 'selection',
		}

    return (
      <div className="page-merchants">
        <Container fluid>

          <Row className="mb-3 align-items-center">
            <Col md={4} lg={6}>
              <h3 className="mb-3 mb-md-0 text-center text-md-left">Merchant Locations</h3>
            </Col>

            <Col md={8} lg={6}>
              <Form>
                <Row form>

                  <Col xs="auto" className="pl-0 pr-0 order-2 order-md-0">
                    <Button color="link" className="text-muted pl-1 pr-1 pl-md-2 pr-md-2">
                      <img src="/icons/download.svg" alt="Export" />
                      <span className="d-none d-md-inline ml-1">Export</span>
                    </Button>
                  </Col>

                  <Col className="mb-1 mb-md-0">
                    <FormGroup className="dropdown-toggle mb-0 input-inline">
                      <Input type="select" name="select" id="applicationStatus">
                        <option value="">All Locations</option>
                        <option value="location1">American Dental – Brooklyn</option>
                        <option value="location1">American Dental – Gold Coast</option>
                        <option value="location1">American Dental – Hollywood</option>
                        <option value="location1">American Dental – San Diego</option>
                        <option value="location1">American Dental – Tampa</option>
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup className="mb-0 input-inline dropdown-toggle">
                      <Input
                        type="text"
                        name="search"
                        id="searchField"
                        className="date-picker"
                        defaultValue="This Month"
                        onClick={this.handleOpenDates}
                        onBlur={this.handleCloseDates} />
                      <DateRangePicker
                        className={ datesModalOpen ? 'd-flex' : 'd-none' }
                				ranges={[selectionRange]}
                        color="#3989E3"
                				onChange={this.handleSelect}
                			/>
                    </FormGroup>
                  </Col>

                </Row>
              </Form>
            </Col>

          </Row>
          <Row>

            <Col>
              <Card>
                <CardHeader className="text-md-left">All Applications</CardHeader>

                <Table className="mb-0" size="sm" style={{ overflow: "visible" }} responsive striped borderless hover>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Status
                        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} className="filter">
                          <DropdownToggle className={ filterActive ? 'active' : '' } />
                          <DropdownMenu>
                            <div className="dropdown-content">
                              <FormGroup className="input-inline">
                                <Input type="text" name="filter-input" id="FilterInput" placeholder="Filter by..." />
                              </FormGroup>
                              <FormGroup className="mb-0">
                                <CustomInput type="checkbox" id="FilterCheckbox1" label="Filter Option" />
                                <CustomInput type="checkbox" id="FilterCheckbox2" label="Filter Option" />
                                <CustomInput type="checkbox" id="FilterCheckbox3" label="Filter Option" />
                                <CustomInput type="checkbox" id="FilterCheckbox4" label="Filter Option" />
                                <CustomInput type="checkbox" id="FilterCheckbox5" label="Filter Option" className="mb-1" />
                                <a href="/">Select All</a>
                              </FormGroup>
                            </div>
                            <div className="dropdown-content d-flex">
                              <Button size="sm" color="primary" className="mr-1" onClick={this.handleFilterApply}>Apply</Button>
                              <Button size="sm" onClick={this.handleFilterCancel}>Cancel</Button>
                              <Button
                                size="sm"
                                color="link"
                                onClick={this.handleFilterCancel}
                                className="btn-icon btn-edit d-inline-block p-0 ml-auto"
                              >
                                <img src="/icons/trash.svg" alt="Trash" style={{ top: "-2px" }} />
                              </Button>
                            </div>
                          </DropdownMenu>
                        </Dropdown>
                      </th>
                      <th>Merchant <span className="filter" /></th>
                      <th className="text-center">Apps Submitted</th>
                      <th className="text-center">Apps Approved</th>
                      <th className="text-center">Apps Funded</th>
                      <th className="text-right">Funding Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="clickable-row" onClick={() => window.open('/corp/merchant-detail', '_self')}>
                      <th scope="row">29383</th>
                      <td><Badge color="success" className="w-100">Enrolled</Badge></td>
                      <td>American Dental – Brooklyn</td>
                      <td className="text-center">2,394</td>
                      <td className="text-center">1,283</td>
                      <td className="text-center">837</td>
                      <td className="text-right">$1,293,304.93</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/corp/merchant-detail', '_self')}>
                      <th scope="row">29383</th>
                      <td><Badge color="success" className="w-100">Enrolled</Badge></td>
                      <td>American Dental – Gold Coast</td>
                      <td className="text-center">2,394</td>
                      <td className="text-center">1,283</td>
                      <td className="text-center">837</td>
                      <td className="text-right">$1,293,304.93</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/corp/merchant-detail', '_self')}>
                      <th scope="row">29383</th>
                      <td><Badge color="success" className="w-100">Enrolled</Badge></td>
                      <td>American Dental – Hollywood</td>
                      <td className="text-center">2,394</td>
                      <td className="text-center">1,283</td>
                      <td className="text-center">837</td>
                      <td className="text-right">$1,293,304.93</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/corp/merchant-detail', '_self')}>
                      <th scope="row">29383</th>
                      <td><Badge color="success" className="w-100">Enrolled</Badge></td>
                      <td>American Dental – San Diego</td>
                      <td className="text-center">2,394</td>
                      <td className="text-center">1,283</td>
                      <td className="text-center">837</td>
                      <td className="text-right">$1,293,304.93</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/corp/merchant-detail', '_self')}>
                      <th scope="row">29383</th>
                      <td><Badge color="success" className="w-100">Enrolled</Badge></td>
                      <td>American Dental – Tampa</td>
                      <td className="text-center">2,394</td>
                      <td className="text-center">1,283</td>
                      <td className="text-center">837</td>
                      <td className="text-right">$1,293,304.93</td>
                    </tr>
                  </tbody>
                </Table>

              </Card>

              <small className="d-block text-right text-muted">Last updated at 12:33PM on 7/25/2019</small>
            </Col>

          </Row>

        </Container>
      </div>
    )
  }
}

export default CorpMerchants;
